import { render, staticRenderFns } from "./SelectedReseller.vue?vue&type=template&id=2b03e1d6&scoped=true&"
import script from "./SelectedReseller.vue?vue&type=script&lang=js&"
export * from "./SelectedReseller.vue?vue&type=script&lang=js&"
import style0 from "./SelectedReseller.vue?vue&type=style&index=0&id=2b03e1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03e1d6",
  null
  
)

export default component.exports